module.exports = __webpack_public_path__ + "static/media/S3N3-3.1f9c12db.svg";